import { render, staticRenderFns } from "./ShortCourseBundles.vue?vue&type=template&id=68b6eb16&"
import script from "./ShortCourseBundles.vue?vue&type=script&lang=js&"
export * from "./ShortCourseBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports